import React from 'react';
import logo from './gtech3.png';
import './App.css';
import CssBaseline from '@material-ui/core/CssBaseline';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Paper from '@material-ui/core/Paper';
import Card from './Card'
import content from './data.json'
import RequestButton from './RequestButton'
import Button from 'react-bootstrap/Button';
import sample from './background.mp4';
import ReactDOM from 'react-dom'
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom'



function App() {

  return (
    <Container >

      <video className='background-video' autoPlay loop muted playsInline >
          <source src={sample} type='video/mp4' />
      </video>
        <div class="overlayLogo">
        <RequestButton />
        </div>
      <div class="overlay">

      <img  width='100%' height='100%' src={logo} />


        <Container >
        <Card data={content.services} />
        <Card data={content.updates} />
        <Card data={content.Technology} />
        <Card data={content.Languages} />
        </Container>

    </div>

  </Container>






  );
}

export default App;
